import React from 'react';
//import { Typography } from 'antd';
import { ProductsData } from '../../../data/product/productsData';
import '../styles.scss';
import ProductList from './ProductList';
import TopBar from '../global_components/TopBar';
import LayoutPage from '../../../layouts/Main';
import '../supplier/productLit.css';

export default function SupplierAllProducts(props) {
  //let role = localStorage.getItem('role');
  const productsData = ProductsData;

  return (
    <LayoutPage>
      <ProductList
        products={productsData}
        catalog={null}
        category={null}
        isSupplier={true}
      />
    </LayoutPage>
  );
}